import { render, staticRenderFns } from "./analysis-report.vue?vue&type=template&id=2fb940bc&scoped=true&"
import script from "./analysis-report.vue?vue&type=script&lang=ts&"
export * from "./analysis-report.vue?vue&type=script&lang=ts&"
import style0 from "./analysis-report.vue?vue&type=style&index=0&id=2fb940bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb940bc",
  null
  
)

export default component.exports